import type { ValueOf } from '@kc-console/core';
import type { SpinnerSize } from '../Spinner';

export const ButtonBaseVariantSet = [
  'accent',
  'primary',
  'secondary',
  'tertiary',
  'danger',
  'inverse',
] as const;
export type ButtonBaseVariant = ValueOf<typeof ButtonBaseVariantSet>;

export const ButtonBaseSizeSet = ['xl', 'lg', 'md', 'sm'] as const;
export type ButtonBaseSize = ValueOf<typeof ButtonBaseSizeSet>;

export const ButtonBaseLoadingPositionSet = ['center', 'start', 'end'] as const;
export type ButtonBaseLoadingPosition = ValueOf<typeof ButtonBaseLoadingPositionSet>;

export const ButtonBaseSpinnerSizeMap: Record<ButtonBaseSize, SpinnerSize> = {
  sm: 'sm',
  md: 'sm',
  lg: 'md',
  xl: 'md',
};
